import { Brand, BrandConfig } from '../app/shared/models/brand.model';

export const BRAND_CONFIGS: Record<Brand, BrandConfig> = {
    autobrief: {
        appName: 'Briefd',
        primaryColor: '#149A58',
        primaryDark: '#2F6C5B',
        primaryWashed: '#ECF8EC',
        primaryWashedOff: '#F2FAF2',
        successColor: '#149A58',
        successWashed: '#E8F5EE',
        logoSrc: 'assets/images/autobrief-logo.svg',
        logoSrcLight: 'assets/images/autobrief-logo-light.svg',
        faviconDir: 'assets/favicon/light/',
    },
    carpeak: {
        appName: 'CarPeak',
        primaryColor: '#50BFC1',
        primaryDark: '#1A6E6D',
        primaryWashed: '#E0F9F8',
        primaryWashedOff: '#F0FCFB',
        successColor: '#149A58',
        successWashed: '#E8F5EE',
        logoSrc: 'assets/images/carpeak-logo.svg',
        logoSrcLight: 'assets/images/carpeak-logo-light.svg',
        faviconDir: 'assets/favicon/carpeak/',
    },
};
